import Builder, { initialValues as builderInitialValues } from '../OrgAssessment/Builder';
import Player from './Player';

export default {
    handle: 'individual',
    label: 'Individual Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
